// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"CatalogAbout__paragraph","columnsContainer":"CatalogAbout__columnsContainer","column":"CatalogAbout__column"};